import { Link } from "react-router-dom";
import { brand, footerNav, footerServices, legalLinks } from "@/mocks/navigation";
import ActionButton from "@/components/base/ActionButton";

export default function Footer() {
  return (
    <footer className="relative w-full bg-primary-950 text-background-100">
      <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-accent-500 to-primary-700" />
      <div className="mx-auto w-full max-w-container px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-sm font-extrabold tracking-tight text-background-50">
                  {brand.shortName}
                </span>
                <span className="mt-1 font-label text-[10px] font-semibold uppercase tracking-[0.18em] text-primary-300">
                  {brand.descriptor}
                </span>
              </span>
            </Link>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-background-200">
              A technology collaboration working to make vehicle electrification practical through
              advanced EV retrofit engineering. {brand.secondary}
            </p>
            <p className="mt-6 font-label text-xs uppercase tracking-[0.16em] text-primary-300">
              {brand.closing}
            </p>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-background-300">
              Navigation
            </h3>
            <ul className="mt-5 space-y-3">
              {footerNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-100 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-background-300">
              Services
            </h3>
            <ul className="mt-5 space-y-3">
              {footerServices.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-100 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-background-300">
              Contact
            </h3>
            <p className="mt-5 text-sm leading-relaxed text-background-200">
              Official contact details will be published here once verified. For every enquiry, our
              team responds through the official enquiry channel.
            </p>
            <div className="mt-5 flex flex-col gap-3">
              <ActionButton to="/contact" variant="primary" size="sm" icon="ri-mail-send-line">
                Send an Enquiry
              </ActionButton>
              <ActionButton
                to="/ev-retrofit#eligibility"
                variant="outlineLight"
                size="sm"
                icon="ri-flashlight-line"
              >
                Check Retrofit Eligibility
              </ActionButton>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-6 border-t border-background-50/15 pt-8 lg:flex-row lg:items-center lg:justify-between">
          <p className="text-xs leading-relaxed text-background-300">
            &copy; {new Date().getFullYear()} {brand.legalName} All Rights Reserved.
          </p>
          <ul className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {legalLinks.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="text-xs text-background-300 transition-colors hover:text-primary-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <p className="mt-6 max-w-4xl text-[11px] leading-relaxed text-background-300/80">
          {brand.shortName} is presented as a technology collaboration. Final retrofit feasibility,
          configuration, cost, range and applicable approvals are subject to technical assessment and
          depend on the vehicle, design and regulations.
        </p>
      </div>
    </footer>
  );
}